module.exports = __webpack_public_path__ + "static/media/search_person.dd64a50f.svg";